import Button from 'Components/Atoms/Button/Button';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import { useEffect, useState } from 'react';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { connect } from 'react-redux';
import { StoreState } from 'Store/Reducers';
import { getActiveFieldsByEntityIdAsArray, getFieldsById } from 'Store/Settings/Fields/Selectors';
import { createLayout, patchLayout } from 'Store/Settings/Layout/Actions';
import { isLayoutCreating, isLayoutPatching } from 'Store/Settings/Layout/Selectors';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { prepareDualListBox } from 'Services/helpers';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { FieldType } from 'Store/FieldManagement/PropTypes';

const LayoutCreateModal = ({
    onClose, type_id, entity_id,
    isCreating,
    fields,
    ...props
}: LayoutFieldsModalProps) => {
    const [state, setState] = useState({
        isValid: false
    });
    const [data, setData] = useState({
        entity_id: entity_id,
        type_id: type_id,
        name: '',
        attributes: {
            width: 1,
            axis: 1,
            columns: 1,
            order: 1
        },
        fields: []
    });

    const handleChange = (key: string, value: any) => {
        const newData = {
            ...data,
            [key]: value
        }
        setData(newData);
        validate(newData);
    }

    const validate = (newData: any) => {
        let isValid = false;

        if (newData.name && newData.fields.length > 0) {
            isValid = true;
        }
        
        setState({
            ...state,
            isValid
        });
    }

    const handleSave = () => props.createLayout(data);

    useEffect(() => {
        if (!isCreating && data.name) onClose();
    }, [isCreating]);
    
    return <Modal>
        <ModalHeader>
            <Title size='large' weight='bold'>
                Layout aanmaken
            </Title>
        </ModalHeader>
        <br/>
        <Container>
            <FormGroup title='Naam'>
                <Field
                    isEdit={true}
                    value={data?.name}
                    onChange={(value: any) => handleChange('name', value)}
                    type={FieldType.Text}
                />
            </FormGroup>
            <FormGroup title='Breedte'>
                <Field
                    isEdit={true}
                    value={data?.attributes?.width}
                    onChange={(value: any) => handleChange('attributes', {
                        ...data.attributes,
                        width: value
                    })}
                    type={FieldType.Radio}
                    fieldProperties={{
                        list: [{
                            label: '50%',
                            value: 1
                        }, {
                            label: '100%',
                            value: 2
                        }]
                    }}
                />
            </FormGroup>
            <FormGroup title='As'>
                <Field
                    isEdit={true}
                    value={data?.attributes?.axis}
                    onChange={(value: any) => handleChange('attributes', {
                        ...data.attributes,
                        axis: value
                    })}
                    type={FieldType.Radio}
                    fieldProperties={{
                        list: [{
                            label: 'Horizontaal',
                            value: 1
                        }, {
                            label: 'Verticaal',
                            value: 2
                        }]
                    }}
                />
            </FormGroup>
            <FormGroup title='Kolommen'>
                <Field
                    isEdit={true}
                    value={data?.attributes?.columns}
                    onChange={(value: any) => handleChange('attributes', {
                        ...data.attributes,
                        columns: value
                    })}
                    type={FieldType.Radio}
                    fieldProperties={{
                        list: [{
                            label: '1 kolom',
                            value: 1
                        }, {
                            label: '2 kolommen',
                            value: 2
                        }]
                    }}
                />
            </FormGroup>
            <FormGroup title='Positie'>
                <Field
                    isEdit={true}
                    value={data?.attributes?.order}
                    onChange={(value: any) => handleChange('attributes', {
                        ...data.attributes,
                        order: value
                    })}
                    type={FieldType.Number}
                />
            </FormGroup>
            <FormGroup title='Velden'>
                <DualListBox
                    className='duallistbox'
                    preserveSelectOrder
                    showOrderButtons
                    options={prepareDualListBox(fields)}
                    selected={data?.fields}
                    onChange={(value: any) => handleChange('fields', value)}
                />
            </FormGroup>
        </Container>
        <br/>
        <ModalFooter>
            <ButtonGroup>
                { !isCreating &&
                    <Button
                        variant="transparent"
                        onClick={onClose}
                    >
                        Annuleren
                    </Button>
                }
                <Button
                    color="primary"
                    variant="solid"
                    isLoading={isCreating}
                    onClick={handleSave}
                    isDisabled={!state.isValid}
                >
                    Aanmaken
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>;
} 

interface Props {
    type_id: any
    entity_id: any
    onClose: any
}

const mapState = (state: StoreState, props: Props) => ({
    fieldsById: getFieldsById(state),
    fields: getActiveFieldsByEntityIdAsArray(state, props.entity_id),
    isCreating: isLayoutCreating(state)
});

const mapDispatch = {
    createLayout,
    patchLayout
}

type LayoutFieldsModalProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(LayoutCreateModal);